<template>
  <div class="form-page">
    <div
      v-for="(section, sectionIndex) in page.sections"
      :key="`section-${sectionIndex}`"
      class="form-section mb-0"
    >
      <v-row no-gutters>
        <v-col
          v-for="(column, columnIndex) in section.columns"
          :key="`column-${columnIndex}`"
          class="px-2"
        >
          <div
            v-for="(field, fieldIndex) in column.items"
            :key="`field-${fieldIndex}`"
            class="mb-2"
          >
            <field
              :component="component"
              :field="field"
              :fieldId="getFieldId(sectionIndex, columnIndex, fieldIndex)"
              :value="getFieldValue(sectionIndex, columnIndex, fieldIndex)"
              :validation-error="
                getValidationError(sectionIndex, columnIndex, fieldIndex)
              "
              :hasAttemptedSubmit="hasAttemptedSubmit"
              @update:value="
                updateValue($event, sectionIndex, columnIndex, fieldIndex)
              "
              @table-edit-state-change="handleTableEditStateChange"
              @clear-validation="
                handleClearValidation(sectionIndex, columnIndex, fieldIndex)
              "
              @validation-error="handleValidationError"
              @validation-event="handleValidationEvent"
              @upload-status-change="handleUploadStatusChange"
            />
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import Field from "./Field.vue";

export default {
  components: {
    Field
  },
  props: {
    page: {
      type: Object,
      required: true
    },
    component: {
      type: Object,
      required: true
    },
    pageIndex: {
      type: Number,
      required: true
    },
    formValues: {
      type: Object,
      required: true
    },
    validationErrors: {
      type: Object,
      default: () => ({})
    },
    hasAttemptedSubmit: {
      type: Boolean,
      default: false
    }
  },
  created() {},
  watch: {},
  methods: {
    getFieldId(sectionIndex, columnIndex, fieldIndex) {
      return `field_${this.pageIndex}_${sectionIndex}_${columnIndex}_${fieldIndex}`;
    },

    getFieldValue(sectionIndex, columnIndex, fieldIndex) {
      const fieldId = this.getFieldId(sectionIndex, columnIndex, fieldIndex);
      return this.formValues[fieldId];
    },

    getValidationError(sectionIndex, columnIndex, fieldIndex) {
      const fieldId = this.getFieldId(sectionIndex, columnIndex, fieldIndex);
      return this.validationErrors && this.validationErrors[fieldId]
        ? this.validationErrors[fieldId]
        : null;
    },

    updateValue(value, sectionIndex, columnIndex, fieldIndex) {
      const fieldId = this.getFieldId(sectionIndex, columnIndex, fieldIndex);
      const field = this.page.sections[sectionIndex].columns[columnIndex].items[
        fieldIndex
      ];

      // For radio fields, ensure allOptions is updated
      if (field.type === "radio" && field.allOptions) {
        field.allOptions.forEach(opt => {
          opt.isSelected = opt.value === value;
        });
      }

      // Emit the value update
      this.$emit("update:form-value", fieldId, value);
    },

    handleTableEditStateChange(event) {
      this.$emit("table-edit-state-change", event);
    },

    handleClearValidation(sectionIndex, columnIndex, fieldIndex) {
      const fieldId = this.getFieldId(sectionIndex, columnIndex, fieldIndex);

      // Get field value to log
      const value = this.getFieldValue(sectionIndex, columnIndex, fieldIndex);
      const field = this.page.sections[sectionIndex].columns[columnIndex].items[
        fieldIndex
      ];

      this.$emit("clear-validation", sectionIndex, columnIndex, fieldIndex);
    },

    // Handle validation error from Field components
    handleValidationError(errorData) {
      // Forward the validation error to the parent form
      this.$emit("validation-error", errorData);
    },

    handleUploadStatusChange(event) {
      this.$emit("upload-status-change", event);
    },

    handleValidationEvent(validationEvent) {
      // Forward the validation event to the parent form
      this.$emit("validation-event", validationEvent);
    }
  }
};
</script>

<style scoped>
.form-page {
  padding: 0;
}

.page-title {
  margin-bottom: 20px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.87);
}

.form-section {
  border-radius: 4px;
  padding: 10px;
}

.v-stepper__header {
  -webkit-box-shadow: 0 0px 0px 0px rgb(0 0 0 / 0%), 0 0px 0px 0 rgb(0 0 0 / 0%),
    0 0px 0px 0 rgb(0 0 0 / 0%);
  box-shadow: 0 0px 0px 0px rgb(0 0 0 / 0%), 0 0px 0px 0 rgb(0 0 0 / 0%),
    0 0px 0px 0 rgb(0 0 0 / 0%);
}

.v-sheet.v-stepper:not(.v-sheet--outlined) {
  -webkit-box-shadow: 0 0px 0px 0px rgb(0 0 0 / 0%), 0 0px 0px 0 rgb(0 0 0 / 0%),
    0 0px 0px 0 rgb(0 0 0 / 0%);
  box-shadow: 0 0px 0px 0px rgb(0 0 0 / 0%), 0 0px 0px 0 rgb(0 0 0 / 0%),
    0 0px 0px 0 rgb(0 0 0 / 0%);
}
</style>
